import React from 'react';
import styled from 'styled-components';
import { colors, fonts } from '../styles/globals';

const BenefitsContainer = styled.section`
  background: linear-gradient(135deg, ${colors.background} 0%, ${colors.white} 100%);
  padding: 80px 20px;
  text-align: center;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

const BenefitsContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const BenefitsTitle = styled.h2`
  font-family: ${fonts.playfair};
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 16px;
  line-height: 1.2;
`;

const BenefitsSubtitle = styled.p`
  font-family: ${fonts.inter};
  font-size: 1.2rem;
  font-weight: 500;
  color: ${colors.text};
  margin-bottom: 50px;
  line-height: 1.5;
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-top: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const BenefitCard = styled.div`
  background: ${colors.white};
  border-radius: 20px;
  padding: 40px 30px;
  box-shadow: 0 10px 30px rgba(45, 31, 64, 0.1);
  border: 1px solid rgba(110, 168, 247, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(135deg, ${colors.accent} 0%, ${colors.secondary} 100%);
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(45, 31, 64, 0.15);
  }

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

const BenefitIcon = styled.div`
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, ${colors.accent} 0%, ${colors.secondary} 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 24px;
  color: ${colors.white};
  box-shadow: 0 8px 20px rgba(243, 156, 107, 0.3);
`;

const BenefitTitle = styled.h3`
  font-family: ${fonts.playfair};
  font-size: 1.3rem;
  font-weight: 600;
  color: ${colors.primary};
  margin-bottom: 15px;
  line-height: 1.3;
`;

const BenefitDescription = styled.p`
  font-family: ${fonts.inter};
  font-size: 1rem;
  color: ${colors.text};
  line-height: 1.6;
  opacity: 0.8;
`;

function BenefitsSection() {
  const benefits = [
    {
      icon: '✓',
      title: 'Superas el miedo escénico desde dentro',
      description: 'No solo aprendes técnicas, sino que sanas las emociones que te bloquean al hablar en público.'
    },
    {
      icon: '✓',
      title: 'Te sientes libre, seguro y con propósito al comunicar',
      description: 'Desarrollas una confianza auténtica que nace de tu verdad interior, no de fingir seguridad.'
    },
    {
      icon: '✓',
      title: 'Tu mensaje tiene impacto porque nace de tu historia real',
      description: 'Aprendes a conectar tu experiencia personal con tu comunicación para crear un impacto genuino.'
    },
    {
      icon: '✓',
      title: 'No finges ser un buen orador, te conviertes en uno auténtico',
      description: 'La autenticidad reemplaza la actuación. Tu voz se convierte en una extensión natural de tu ser.'
    }
  ];

  return (
    <BenefitsContainer>
      <BenefitsContent>
        <BenefitsTitle>La promesa: Qué pasa cuando liberas tu voz</BenefitsTitle>
        <BenefitsSubtitle>
          Hablar desde tu poder cambia tu vida.
        </BenefitsSubtitle>

        <BenefitsGrid>
          {benefits.map((benefit, index) => (
            <BenefitCard key={index}>
              <BenefitIcon>{benefit.icon}</BenefitIcon>
              <BenefitTitle>{benefit.title}</BenefitTitle>
              <BenefitDescription>{benefit.description}</BenefitDescription>
            </BenefitCard>
          ))}
        </BenefitsGrid>
      </BenefitsContent>
    </BenefitsContainer>
  );
}

export default BenefitsSection; 